// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-list__loading,\n.van-list__finished-text,\n.van-list__error-text {\n  color: #969799;\n  font-size: 0.37333rem;\n  line-height: 1.33333rem;\n  text-align: center;\n}\n.van-list__placeholder {\n  height: 0;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
